import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { CheckIcon } from 'lucide-react';
export function STAddOns() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1943">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1944">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1945">
          <h2 className="text-[28px] lg:text-[44px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1946">
            ADD ONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1947"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1948">
          {/* Exosomes */}
          <AnimateOnScroll data-id="element-1949">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-1950">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-1951">
                Exosomes
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body" data-id="element-1952">
                Enhance your SkinTyte treatment with exosomes for even better
                results. When applied immediately after your laser treatment,
                exosomes amplify healing and skin regeneration by delivering
                growth factors and proteins directly to your skin cells. This
                boosts cellular communication and collagen production, reducing
                inflammation and improving skin texture, tone, and overall
                health. Elevate your skincare routine by supplementing SkinTyte
                with exosomes for a radiant, rejuvenated complexion.
              </p>
            </div>
          </AnimateOnScroll>

          {/* Rejuran */}
          <AnimateOnScroll delay={100} data-id="element-1953">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-1954">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-1955">
                Rejuran
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body" data-id="element-1956">
                Rejuran is essentially a skin-healing procedure occurring from
                the inside out, safely using salmon DNA, so any improvements
                will be gradual and take time to show. You can expect gradual
                improvement of skin texture and tone over a 4 to 6 week period
                after treatment. It's the perfect add-on to optimize your
                SkinTyte treatment.
              </p>
            </div>
          </AnimateOnScroll>

          {/* "Time Zero" Stem Cells */}
          <AnimateOnScroll delay={200} data-id="element-1957">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full relative" data-id="element-1958">
              <span className="absolute top-4 right-4 bg-[#FF1493] text-white text-[11px] font-bold uppercase tracking-[2px] px-3 py-1 rounded-full font-[Poppins,_sans-serif]" data-id="element-1959">
                Coming Soon
              </span>
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-1960">
                "Time Zero" Stem Cells
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body" data-id="element-1961">
                Stay tuned for this coming soon treatment to Be CLINICAL! We are
                so excited to add stem cell therapy to our list of rejuvenating
                treatments for gorgeous, flawless skin at any age!
              </p>
            </div>
          </AnimateOnScroll>

          {/* Power Trio */}
          <AnimateOnScroll delay={300} data-id="element-1962">
            <div className="bg-[#111111] p-9 border-t-[3px] border-[#FF1493] h-full" data-id="element-1963">
              <h3 className="text-white text-[22px] font-bold font-[Poppins,_sans-serif] mb-4" data-id="element-1964">
                Our Proprietary "Power Trio"
              </h3>
              <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body mb-6" data-id="element-1965">
                Optimize your SkinTyte treatment with Be CLINICAL's exclusive
                Power Trio blend. This proprietary mix includes stem cells,
                brightening agents, and peptides, all working together for
                glowing, beautiful results.
              </p>
              <ul className="space-y-4" data-id="element-1966">
                <li className="flex items-start gap-3" data-id="element-1967">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-1968" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-1969">
                    <strong className="text-white" data-id="element-1970">Stem Cells</strong> – Our
                    products contain powerful growth factors that stimulate
                    cells to behave younger, promoting rejuvenation and vitality
                    in your skin.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1971">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-1972" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-1973">
                    <strong className="text-white" data-id="element-1974">Brightening Agents</strong> –
                    A potent combination of glutathione and tranexamic acid
                    evens out your skin tone, giving you a luminous complexion.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1975">
                  <CheckIcon size={18} className="text-[#FF1493] flex-shrink-0 mt-1" data-id="element-1976" />
                  <span className="text-[#B0B0B0] text-sm leading-[1.6] font-body" data-id="element-1977">
                    <strong className="text-white" data-id="element-1978">Peptides</strong> – Our
                    advanced formula works on a cellular level to improve skin
                    cell function, providing them with the necessary building
                    blocks for optimal health and vitality.
                  </span>
                </li>
              </ul>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}